import axios from "axios";

const mock = (process.env.REACT_APP_MOCK !== "N");
const baseUrl = process.env.REACT_APP_BASE_URL;
const mockBaseUrl = "mockapi/";

export function simWorldCupResult(params) {
    const url = mock ? mockBaseUrl + "result.json" : baseUrl + "result";
    return axios.get(url, { params: params });
}

export function simWorldCupResultAgain(worldCupResult) {
    if (mock) {
        return axios.get(mockBaseUrl + "result.json");
    }
    return axios.post(baseUrl + "result", worldCupResult);
}

export function fetchTeams(params) {
    const url = mock ? mockBaseUrl + "teams.json" : baseUrl + "teams";
    return axios.get(url, { params: params });
}